export default "__VITE_ASSET__DDys0Khg__"